var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 14.1246H10.25V19.1246H9C8.83424 19.1246 8.67527 19.1905 8.55806 19.3077C8.44085 19.4249 8.375 19.5839 8.375 19.7496C8.375 19.9154 8.44085 20.0743 8.55806 20.1916C8.67527 20.3088 8.83424 20.3746 9 20.3746H24C24.1658 20.3746 24.3247 20.3088 24.4419 20.1916C24.5592 20.0743 24.625 19.9154 24.625 19.7496C24.625 19.5839 24.5592 19.4249 24.4419 19.3077C24.3247 19.1905 24.1658 19.1246 24 19.1246H22.75V14.1246H24.625C24.761 14.1245 24.8932 14.08 25.0016 13.9979C25.1101 13.9158 25.1887 13.8006 25.2258 13.6698C25.2628 13.5389 25.2561 13.3995 25.2068 13.2728C25.1574 13.1461 25.0681 13.0389 24.9523 12.9676L16.8273 7.96758C16.7289 7.90705 16.6156 7.875 16.5 7.875C16.3844 7.875 16.2711 7.90705 16.1727 7.96758L8.04766 12.9676C7.9319 13.0389 7.84257 13.1461 7.79323 13.2728C7.74388 13.3995 7.73722 13.5389 7.77424 13.6698C7.81126 13.8006 7.88994 13.9158 7.99836 13.9979C8.10678 14.08 8.23901 14.1245 8.375 14.1246ZM11.5 14.1246H14V19.1246H11.5V14.1246ZM17.75 14.1246V19.1246H15.25V14.1246H17.75ZM21.5 19.1246H19V14.1246H21.5V19.1246ZM16.5 9.2332L22.4172 12.8746H10.5828L16.5 9.2332ZM25.875 22.2496C25.875 22.4154 25.8092 22.5743 25.6919 22.6916C25.5747 22.8088 25.4158 22.8746 25.25 22.8746H7.75C7.58424 22.8746 7.42527 22.8088 7.30806 22.6916C7.19085 22.5743 7.125 22.4154 7.125 22.2496C7.125 22.0839 7.19085 21.9249 7.30806 21.8077C7.42527 21.6905 7.58424 21.6246 7.75 21.6246H25.25C25.4158 21.6246 25.5747 21.6905 25.6919 21.8077C25.8092 21.9249 25.875 22.0839 25.875 22.2496Z",
    fill: "#9333EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.ea40728946d7fd48f73344fc08c6e4d4.svg";
export { ForwardRef as ReactComponent };